import React from 'react'
import { HomeHero, HomeJuxtapose, HomeSkills, HomeApproach, HomeProcess, HomeWork, HomeMap } from "../components/home"
import { Footer } from '../components/Footer';
const IndexPage = () => (
    <div className="home">
        <HomeHero></HomeHero>
        <HomeJuxtapose></HomeJuxtapose>
        <HomeSkills></HomeSkills>
        <HomeApproach></HomeApproach>
        <HomeProcess></HomeProcess>
        <HomeWork></HomeWork>
        <HomeMap></HomeMap>
        <Footer />
    </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js